import { getMobileAndDesktopFirstImage } from '../utils';
import { ComparisonTableColumn, ComparisonTableProps } from './ComparisonTable';

export const parseComparisonTable = (
  section: Queries.ContentfulSection001,
): ComparisonTableProps => {
  const { eyebrow, metadata, subsections } = section || {};
  const { title } = metadata || {};

  const tableColumns: ComparisonTableColumn[] =
    subsections
      ?.filter(
        (subsection): subsection is Queries.ContentfulSection001 =>
          subsection !== null,
      )
      .map((subsection: Queries.ContentfulSection001) => {
        const { metadata: subSectionMetadata, images } = subsection || {};
        const { flags, theme: headerTheme, ctas } = subSectionMetadata || {};

        const { mobileImage, desktopImage } =
          getMobileAndDesktopFirstImage(images);

        return {
          header: {
            text: subSectionMetadata?.title,
            backgroundColor: headerTheme?.backgroundColor,
            textColor: headerTheme?.textColor,
            mobileImage,
            desktopImage,
            cta: ctas && ctas?.[0] ? ctas[0] : null,
          },
          rows: flags?.map((flag) => {
            const { displayText, metadata } = flag || {};
            const { theme: flagTheme, context: flagContext } = metadata || {};

            return {
              text: displayText,
              textColor: flagTheme?.textColor,
              iconName: flagContext?.iconName,
              iconColor: flagContext?.iconColor,
              backgroundColor: flagTheme?.backgroundColor,
            };
          }),
        };
      }) || [];

  return {
    eyebrow,
    title,
    tableColumns,
  };
};
